var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { CommitteeIdentifier, CommitteeRole, } from "../../authorization/structures.js";
let EffectiveCommitteeRole = class EffectiveCommitteeRole {
    identifier;
    role;
    static init(identifier, role) {
        const effectiveCommitteeRole = new this();
        effectiveCommitteeRole.identifier = identifier;
        effectiveCommitteeRole.role = role;
        return effectiveCommitteeRole;
    }
};
__decorate([
    Field(() => CommitteeIdentifier, { nullable: false }),
    __metadata("design:type", String)
], EffectiveCommitteeRole.prototype, "identifier", void 0);
__decorate([
    Field(() => CommitteeRole, { nullable: false }),
    __metadata("design:type", String)
], EffectiveCommitteeRole.prototype, "role", void 0);
EffectiveCommitteeRole = __decorate([
    ObjectType("EffectiveCommitteeRole")
], EffectiveCommitteeRole);
export { EffectiveCommitteeRole };
//# sourceMappingURL=EffectiveCommitteeRole.js.map